// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2YxNm","log":"ModalInventoryLogs_log__lK6ok","date":"ModalInventoryLogs_date__30NF5","userName":"ModalInventoryLogs_userName__2YUFU"};